// extracted by mini-css-extract-plugin
export var menu = "HeaderGatewayMenu-module--menu--1e4WV";
export var menuOpen = "HeaderGatewayMenu-module--menuOpen--1syQb";
export var container = "HeaderGatewayMenu-module--container--apV8c";
export var gatewayCity = "HeaderGatewayMenu-module--gatewayCity--12Bnn";
export var gatewayContainer = "HeaderGatewayMenu-module--gatewayContainer--2bErI";
export var gatewayCityContainer = "HeaderGatewayMenu-module--gatewayCityContainer--2S_fm";
export var province = "HeaderGatewayMenu-module--province--22G2B";
export var provinceLabel = "HeaderGatewayMenu-module--provinceLabel--1qE_o";
export var currentGateway = "HeaderGatewayMenu-module--currentGateway--3doBH";